<template>
  <section v-if="invitedOwners.length">
    <p class="mb-2 mt-6 text-left text-neutral-subtle">Invited Owners</p>
    <div class="flex flex-col gap-3">
      <div
        v-for="owner in invitedOwners"
        :key="'Invited-owner-' + owner.id"
        class="flex items-center gap-2 rounded-lg bg-off-white px-3 py-5"
      >
        <OwnerIcon />
        <p class="text-xs text-neutral-subtle md:text-sm">
          {{ formatOwnerEmail(owner) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useStore } from 'vuex';
import { defineProps } from 'vue';
import OwnerIcon from '@/components/icons/OwnerIcon.vue';

const store = useStore();

defineProps({
  invitedOwners: {
    type: Array,
    default: () => [],
  },
});

function formatOwnerEmail(owner) {
  return owner.user_id === store.state.users.currentUser.id
    ? store.state.users.currentUser.email
    : owner.invited_user_email;
}
</script>
